<template>
  <div class="transaction">
    <div class="subheading grey--text mt-6 ml-3">
      <h5 v-if="receivedTransactions">
        Transactions[{{ receivedTransactions.totalRecords }}]
      </h5>
    </div>
    <div class="mx-3 my-8">
      <v-layout row>
        <v-flex xs4 md3>
          <v-tooltip top
            ><template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="transact white--text lowercase-text"
                block
                plain
                @click="dialogs.deposit = true"
              >
                Deposit
              </v-btn> </template
            ><span>Fuel FlexiFund with M-Pesa deposit!</span></v-tooltip
          >
        </v-flex>
        <v-flex xs3 md3 class="ml-4">
          <v-tooltip top
            ><template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="primary white--text lowercase-text"
                block
                plain
                color="primary"
                @click="dialogs.withdraw = true"
                >Withdraw</v-btn
              ></template
            ><span>Tap to withdraw from FlexiFund.</span></v-tooltip
          >
        </v-flex>
      </v-layout>
    </div>
    <div v-if="receivedTransactions">
      <div v-if="receivedTransactions.transactions.length === 0" class="mx-3">
        <v-alert text dense color="disabled" border="left">
          Zero Transactions, Infinite Possibilities. Seize the Moment - Deposit
          Button Above Awaits!🌟
        </v-alert>
      </div>
      <div v-else class="mx-3">
        <v-alert
          v-for="transaction in receivedTransactions.transactions"
          :key="transaction._id"
          border="left"
          colored-border
          :color="getColor(transaction.transactionType)"
          elevation="3"
        >
          <v-layout row wrap
            ><v-flex xs6 sm4 md2 class="pa-2"
              ><div class="caption grey--text">Transaction type</div>
              <div>{{ transaction.transactionType }}</div></v-flex
            ><v-flex xs6 sm4 md2 class="pa-2"
              ><div class="caption grey--text">Amount</div>
              <div>
                <v-chip
                  small
                  :class="getColor(transaction.transactionType)"
                  dark
                  >{{ transaction.amount }}</v-chip
                >
              </div></v-flex
            >
            <v-flex xs6 sm4 md2 class="pa-2"
              ><div class="caption grey--text">From</div>
              <div>{{ transaction.from }}</div></v-flex
            >
            <v-flex xs6 sm4 md2 class="pa-2"
              ><div class="caption grey--text">To</div>
              <div>{{ transaction.to }}</div></v-flex
            >
            <v-flex xs6 sm4 md2 class="pa-2"
              ><div class="caption grey--text">Transaction Status</div>
              <div>
                <v-chip small class="success">{{
                  transaction.transactionStatus
                }}</v-chip>
              </div></v-flex
            >
            <v-flex xs6 sm4 md2 class="pa-2"
              ><div class="caption grey--text">Transaction Time</div>
              <div>{{ transaction.createdAt | niceDate }}</div></v-flex
            >
          </v-layout>
        </v-alert>

        <!-- Pagination -->
        <div class="text-center mt-6">
          <Pagination
            store="transactions"
            collection="transactions"
            action="fetchTransactions"
          />
        </div>
      </div>
    </div>
    <!-- Depsit & withdraw dialoags -->
    <FlexiFundDeposit @close="dialogs.deposit = false" v-if="dialogs.deposit" />
    <FlexiFundWithdraw
      @close="dialogs.withdraw = false"
      v-if="dialogs.withdraw"
    />
  </div>
</template>

<script>
import { format } from "date-fns";
import FlexiFundDeposit from "@/components/wallet/FlexiFundDeposit";
import FlexiFundWithdraw from "@/components/wallet/FlexiFundWithdraw";
import Pagination from "@/components/shared/PaginateGlobal";
export default {
  components: {
    FlexiFundDeposit,
    FlexiFundWithdraw,
    Pagination,
  },
  data() {
    return {
      dialogs: {
        deposit: false,
        withdraw: false,
      },
    };
  },
  created() {
    this.$store.dispatch("transactions/fetchTransactions", 1);
  },
  computed: {
    receivedTransactions() {
      return this.$store.getters["transactions/transactions"];
    },
  },
  filters: {
    niceDate(value) {
      return format(new Date(value), "yyyy-MM-dd h:mm a");
    },
  },
  methods: {
    getColor(transactionType) {
      // Define your CSS classes based on transaction types
      switch (transactionType) {
        case "Withdraw":
          return "primary"; // Define this class in your component's styles
        case "Deposit":
          return "transact";
        case "Transfer":
          return "info";
        // ... define other cases
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
